<template>
<div class="share-dialog-common">
    <div class="share-dialog-main" ref="poster">
        <div class="download-wrap">
            <div class="tl-name">{{shareConfig.info1.name}}</div>
            <div class="main-img-wrap">
                <img class="main-img" :src="shareConfig.mainPicUrl+'?imageView2/1/w/710/h/1000/q80/format/webp'" />
                <div class="time-box">
                    <div class="time">活动时间：{{shareConfig.info1.time}}</div>
                </div>

            </div>

            <div class="info-container">
                <div class="info-main">
                    <div class="title" id="title-box">
                        <div id="title">
                            {{shareConfig.info1.title}}
                        </div>

                    </div>
                </div>
                <div class="qrcode-wrap">
                    <div class="qrcode" id="qrcode">
                      <img :src="qrCode" v-if="qrCode">
                    </div>

                </div>
                <div class="hotel-name">{{shareConfig.info1.hotelName}}</div>
            </div>

        </div>
    </div>
    <transition name="slide-fade">
        <div class="poster-box" v-show="isPoster&&posterImg!=''">
            <div class="posterImg">
                <div class="close" @click="closePoster()">
                    <i class="iconfont iconcha"></i>
                </div>
                <img :src="posterImg" />
            </div>
        </div>
    </transition>
</div>
</template>

<script>
var config = {};
import api from "@/utils/api";
import {
    jAlert3
} from "@/base/jAlert/jAlert";
import QRCode from "qrcodejs2";
import html2canvas from "html2canvas";
import {
    getStorage
} from "@/utils/wxuser";
import { miniProgram } from "@/utils/miniProgram";
export default {
    data() {
        return {
            wxuser: getStorage("wxuser"),
            qrCode: "",
            posterImg: "",
            isPoster: false,
        };
    },
    props: {
        shareConfig: {
            type: Object,
        },
        hasConfigSKU: {
            type: Boolean,
        },
    },
    watch: {
        isPoster(val) {
            if (this.posterImg == "" && val) {
                this.$store.dispatch("openLoading", "加载中...");
            }
        },
    },
    methods: {
        closePoster() {
            this.isPoster = false;
            // this.$emit("close");
        },
        shotPic() {
            html2canvas(this.$refs.poster, {
                useCORS: true,
                // allowTaint: true
            }).then((canvas) => {
                // document.body.appendChild(canvas);
                this.$nextTick(() => {
                    let dataURL = canvas.toDataURL("image/png");
                    this.posterImg = dataURL;
                    this.$store.dispatch("closeLoading");
                });
            });
        },
        ellipsis() {
            var $container = document.getElementById("title-box");
            var $content = document.getElementById("title");
            var str = $content.innerHTML;
            console.log($content.offsetHeight, $container.offsetHeight)
            if ($content.offsetHeight >= $container.offsetHeight) {
                for (var i = 0; i <= str.length; i++) {
                    $content.innerHTML = str.slice(0, i)
                    if ($content.offsetHeight > $container.offsetHeight) {

                        $content.innerHTML = str.slice(0, i - 4) + "..."
                        console.log($content.innerHTML)
                        break;
                    }
                }
            }
        },
        async getShortUrl() {
            var opt = {
                longUrl: this.shareConfig.url,
                appid: config.appid,
                componentAppid: config.componentAppid,
            };
            // this.$store.dispatch("openLoading", "加载中...");
            var codeW = 100;
            var res = await api.getShortUrl(opt)
            if (res.result == 1) {
                var isMiniProgram = await miniProgram.isMiniProgram();
                if (isMiniProgram) {
                    var obj = {
                        hotelCode: config.hotelCode,
                        hotelGroupCode: config.hotelGroupCode,
                        scene: res.retVal,
                        appid: config.appid,
                        componentAppid: config.componentAppid,
                        line_color_g: 0,
                        page: 'pages/mall/webview',
                        width: 500,
                        line_color_b: 0,
                        auto_color: false,
                        is_hyaline: true,
                        line_color_r: 0,
                    }
                    api.getWxacodeUnlimitUrl(obj).then(res => {
                        this.qrCode = res.retVal.imageUrl + '?imageMogr2/thumbnail/150x'
                        this.$nextTick(() => {
                            this.shotPic();
                        })
                    })
                } else {
                    this.$nextTick(() => {
                        let qrcode = new QRCode("qrcode", {
                            width: codeW,
                            height: codeW,
                            text: res.retVal, // 二维码地址
                        });
                        this.shotPic();
                    });
                }

            } else {
                this.$nextTick(() => {
                    let qrcode = new QRCode("qrcode", {
                        width: codeW,
                        height: codeW,
                        text: this.shareConfig.url, // 二维码地址
                    });
                    this.shotPic();
                });
                this.$store.dispatch("closeLoading");
            }

        },
    },

    created() {

        config = getStorage("config");
    },
    mounted() {
        this.$nextTick(() => {
            this.ellipsis();
        })

        this.getShortUrl();
    },
};
</script>

<style lang="less">
@import url("~@/styles/base.less");
@import url("~@/styles/mixin.less");

.share-dialog-common {
    width: 100%;
    overflow: hidden;

    .share-dialog-main {
        position: fixed;
        width: 13.35rem;
        background: #fff;
        overflow: hidden;
        padding: 0 0.32rem 0 0.32rem;
        box-sizing: border-box;
        left: 0;
        top: -100000px;
        z-index: -9;

        .tl-name {
            font-size: 24px;
            color: #273346;
            font-weight: bold;
            text-align: right;
            line-height: 2.2428rem;
        }

        .main-img-wrap {
            position: relative;
        }

        .main-img {
            width: 100%;
            border: 0.0534rem solid #3ea9f4;
            border-radius: 0.4rem;
            overflow: hidden;
            box-sizing: border-box;
        }

        .time-box {
            width: 100%;
            display: flex;
            height: 0.8544rem;
            justify-content: center;
        }

        .time {
            position: absolute;
            bottom: 0.427rem;
            font-size: 14px;
            color: #555555;
            font-weight: bold;
            display: flex;
            align-items: center;
            height: 0.8544rem;
            line-height: 0.8544rem;
            color: #fff;
            padding: 0 0.8rem;
            z-index: 999;
            border-radius: 0.106667rem;
            overflow: hidden;
            white-space: nowrap;
            background: #3ea9f4;
            box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
        }

        .download-wrap {
            .main-img-wrap {
                font-size: 0;

                .main-img {
                    width: 100%;
                    height: 17.8356rem;
                }
            }

            .info-container {
                padding: 0.4rem 0 0.8rem;
                box-sizing: border-box;
                background: #fff;
                display: flex;
                align-items: top;
                justify-content: flex-end;
                position: relative;

                .qrcode-wrap {
                    box-sizing: border-box;
                    text-align: center;
                    padding-right: 0.266667rem;

                    .qrcode {
                        display: inline-block;
                        width: 2.133333rem;
                        height: 2.133333rem;
                        box-sizing: border-box;
                        img{
                            width: 100%;
                            height: 100%;
                        }
                    }
                }

                .info-main {
                    flex: 1;
                    height: 2.666667rem;
                    display: flex;
                    align-items: center;
                    justify-content: flex-end;

                    .title {
                        font-size: 18px;
                        color: #0d468b;
                        line-height: 0.64rem;
                        height: 0.64rem;
                        overflow: hidden;
                        font-weight: bold;
                        margin-right: 0.3738rem;
                    }
                }
            }
        }
    }

    .poster-box {
        z-index: 999;
        background: rgba(0, 0, 0, 0.5);
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        height: 100vh;

        .posterImg {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);

            img {
                width: 75vw;
            }

            .close {
                color: #fff;
                width: 0.8rem;
                height: 0.8rem;
                background: rgba(0, 0, 0, 0.5);
                position: absolute;
                right: 0;
                top: 0;
                margin-right: -0.4rem;
                margin-top: -0.4rem;
                display: flex;
                justify-content: center;
                align-items: center;
                border-radius: 50%;

                i {
                    font-size: 14px;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/shareCommon.vue